import { API } from "aws-amplify";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import { getProjectDetails } from "actions/projects";

export const GET_APPLIANCES_DOWNLOAD_TEMPLATE_REQUEST =
  "@@appliances/GET_APPLIANCES_DOWNLOAD_TEMPLATE_REQUEST";
export const GET_APPLIANCES_DOWNLOAD_TEMPLATE_SUCCESS =
  "@@appliances/GET_APPLIANCES_DOWNLOAD_TEMPLATE_SUCCESS";
export const GET_APPLIANCES_DOWNLOAD_TEMPLATE_FAILURE =
  "@@appliances/GET_APPLIANCES_DOWNLOAD_TEMPLATE_FAILURE";

export function getAppliancesDownloadTemplate(
  id = "",
  organisation,
  sample_table = true
) {
  return async (dispatch) => {
    if (!(id && organisation)) return;
    dispatch({
      type: GET_APPLIANCES_DOWNLOAD_TEMPLATE_REQUEST,
    });
    try {
      let url = "/showdata";
      if (id && organisation) {
        url = `${url}?project_id=${id}&table_name=in_appliance&organisation=${organisation}&sample_table=${sample_table}`;
      }

      const response = await API.get("usimAPI", url);
      dispatch({
        type: GET_APPLIANCES_DOWNLOAD_TEMPLATE_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_APPLIANCES_DOWNLOAD_TEMPLATE_FAILURE,
        payload: error,
      });
    }
  };
}

export const GET_APPLIANCES_LIST_REQUEST =
  "@@appliances/GET_APPLIANCES_LIST_REQUEST";
export const GET_APPLIANCES_LIST_SUCCESS =
  "@@appliances/GET_APPLIANCES_LIST_SUCCESS";
export const GET_APPLIANCES_LIST_FAILURE =
  "@@appliances/GET_APPLIANCES_LIST_FAILURE";

export function getAppliancesList(id = "", organisation) {
  return async (dispatch) => {
    if (!(id && organisation)) return;
    dispatch({
      type: GET_APPLIANCES_LIST_REQUEST,
    });
    try {
      let url = "/showdata";
      if (id && organisation) {
        url = `${url}?project_id=${id}&table_name=in_appliance&organisation=${organisation}&sample_table=false`;
      }

      const response = await API.get("usimAPI", url);
      dispatch({
        type: GET_APPLIANCES_LIST_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_APPLIANCES_LIST_FAILURE,
        payload: error?.response?.data,
      });
    }
  };
}

export const DELETE_APPLIANCES_LIST_REQUEST =
  "@@appliances/DELETE_APPLIANCES_LIST_REQUEST";
export const DELETE_APPLIANCES_LIST_SUCCESS =
  "@@appliances/DELETE_APPLIANCES_LIST_SUCCESS";
export const DELETE_APPLIANCES_LIST_FAILURE =
  "@@appliances/DELETE_APPLIANCES_LIST_FAILURE";

export function deleteAppliancesList(id = "", organisation) {
  return async (dispatch) => {
    if (!(id && organisation)) return;
    dispatch({
      type: DELETE_APPLIANCES_LIST_REQUEST,
    });
    try {
      let url = "/showdata";
      if (id && organisation) {
        url = `${url}?project_id=${id}&table_name=in_appliance&organisation=${organisation}`;
      }

      const response = await API.del("usimAPI", url);
      dispatch({
        type: DELETE_APPLIANCES_LIST_SUCCESS,
        payload: response,
      });
      dispatch(getProjectDetails(id));
    } catch (error) {
      dispatch({
        type: DELETE_APPLIANCES_LIST_FAILURE,
        payload: error?.response?.data,
      });
    }
  };
}

export const UPLOAD_APPLIANCES_DATA_REQUEST =
  "@@appliances/UPLOAD_APPLIANCES_DATA_REQUEST";
export const UPLOAD_APPLIANCES_DATA_SUCCESS =
  "@@appliances/UPLOAD_APPLIANCES_DATA_SUCCESS";
export const UPLOAD_APPLIANCES_DATA_FAILURE =
  "@@appliances/UPLOAD_APPLIANCES_DATA_FAILURE";

export function uploadAppliancesData(
  id = "",
  organisation,
  file,
  columnMappings,
  callback
) {
  return async (dispatch) => {
    if (!id) return;
    dispatch({
      type: UPLOAD_APPLIANCES_DATA_REQUEST,
    });
    try {
      let url = "/presignedurl";
      if (id) {
        url = `${url}?project_id=${id}&table_name=in_appliance`;
      }

      if (!isEmpty(columnMappings)) {
        url = `${url}&column_mappings=${encodeURI(
          JSON.stringify(columnMappings)
        )}`;
      }

      const response = await API.get("usimAPI", url);

      const requestOptions = {
        method: "PUT",
        headers: { "Content-Type": file.type },
        body: file,
      };
      await fetch(response.uploadURL, requestOptions).then((response) => {
        if (response.status === 200) {
          toast.success("Data uploaded successfully!");
          setTimeout(() => {
            dispatch(getAppliancesList(id, organisation));
          }, 2000);
          callback({
            success: true,
          });
        } else {
          dispatch({
            type: UPLOAD_APPLIANCES_DATA_FAILURE,
            payload: {
              message: "Upload data failed.",
            },
          });
        }
      });

      dispatch({
        type: UPLOAD_APPLIANCES_DATA_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: UPLOAD_APPLIANCES_DATA_FAILURE,
        payload: error?.response?.data,
      });
    }
  };
}
